const routes = [
  {
    path: '/gallery',
    name: 'gallery',
    component: () => import(/* webpackChunkName: "attachmentsGallery" */'@/modules/gallery/views/GalleryPage.vue'),
    props: route => ({...route.params})
  },
];

export default routes;
